import Tr from 'translations/Translations';
import VatType from './VatType';

const createItem = (value) => ({
	label: value + '%',
	value: '' + value,
})

const createItemText = (label, value) => ({
	label,
	value,
})

// [0,3,5,7,8,23].map( x => createItem(x))

export const SELECT_VALUE = {
	DEFAULT: null,
	NOT_APPLICABLE: VatType.NOT_APPLICABLE,
	CANCEL: VatType.EXEMPTED,
	REVERSED: VatType.REVERSED,
	DIFFRENT_VAT: VatType.MIXED,
	OTHER: VatType.OTHER,
}

export default [
	createItemText(Tr('not_applicable'), SELECT_VALUE.NOT_APPLICABLE),
	createItemText(Tr('released'), SELECT_VALUE.CANCEL),
	createItemText(Tr('reversed'), SELECT_VALUE.REVERSED),
	createItem(0),
	createItem(3),
	createItem(5),
	createItem(7),
	createItem(8),
	createItem(23),
	createItemText(Tr('different_vat_rates'), SELECT_VALUE.DIFFRENT_VAT),
	createItemText(Tr('other_2'), SELECT_VALUE.OTHER),
]

